import {
  type BasketItem,
  type Product,
  getFirstAttributeValue,
} from '@scayle/storefront-nuxt'
import {
  type BundledBasketItems,
  getPartitionedBasketItems,
  sortBasketItemsByNameAndSize,
  bundleBasketItemsByGroup,
} from '~/utils/basket'
import { Action } from '~/plugins/toast'

const listingMetaData = {
  id: BasketListingMetadata.ID,
  name: BasketListingMetadata.NAME,
}

type OrderedItems<T> = {
  standAlone: T[]
  groupedItems: BundledBasketItems<T>
}

export function useBasketActions() {
  const instance = useNuxtApp()
  const scope = effectScope()

  const { $i18n, $alert } = instance

  const basket = useBasket()
  const tracking = useTrackingEvents()
  const { trackRemoveFromBasket, collectBasketItems: _collectBasketItems } =
    tracking

  const showAddToBasketToast = (
    isAddedToBasket: boolean,
    item: Product | null,
  ) => {
    const productName =
      getFirstAttributeValue(item?.attributes, 'name')?.label ||
      $i18n.t('wishlist.product')

    const message = $i18n.t('basket.notification.add_to_basket_success', {
      productName,
    })

    const action = isAddedToBasket ? Action.route : Action.confirm

    $alert.show(message, action, routeList.basket)
  }

  /** @todo tracking */
  // const getGroupedProducts = (itemGroupId?: string) => {
  //   if (!itemGroupId) {
  //     return
  //   }
  //   return (basket.items.value ?? [])
  //     .filter(({ itemGroup }) => itemGroup?.id === itemGroupId)
  //     .map(({ product }) => product)
  // }

  const removeItem = async ({
    product,
    variant,
    quantity,
    itemGroup,
  }: BasketItem) => {
    /** @todo tracking */
    // const groupedProducts = getGroupedProducts(itemGroup?.id)

    await basket.removeItem({ variantId: variant.id })

    if (!itemGroup) {
      trackRemoveFromBasket(product, quantity, variant)
    } else {
      // trackRemoveFromBasket({ products: groupedProducts })
    }

    // trackBasket(
    //   collectBasketItems(basket.items.value || [], {
    //     listId: listingMetaData.id,
    //     listName: listingMetaData.name,
    //   }),
    // )
  }

  const orderedItems = ref<OrderedItems<BasketItem>>({
    standAlone: [],
    groupedItems: {},
  })

  const updateBasketItems = (items: BasketItem[]) => {
    const data = getPartitionedBasketItems(items)
    return {
      standAlone: sortBasketItemsByNameAndSize(data.standAlone),
      groupedItems: bundleBasketItemsByGroup(
        sortBasketItemsByNameAndSize(data.groupedItems),
      ),
    }
  }

  scope.run(() => {
    if (import.meta.server) {
      return
    }
    watchPostEffect(() => {
      orderedItems.value = updateBasketItems(basket.items.value ?? [])
    })
  })
  tryOnScopeDispose(() => scope.stop())

  const fetching = basket.fetching
  const isBasketEmpty = basket.isEmpty
  const basketData = basket.data
  const basketCount = basket.count
  const basketItems = basket.items

  return extendPromise(
    basket.then(() => ({})),
    {
      removeItem,
      orderedItems,
      fetching,
      basketData,
      basketCount,
      listingMetaData,
      basketItems,
      isBasketEmpty,
      showAddToBasketToast,
    },
  )
}
